// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Styles
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ReceiptContainer.css';

// Component
import Receipt from '../../components/Receipt';
import Loader from '../../components/Loader';
import { withQuery } from '../../hoc/withGraphql';

// Graphql
import getReceiptQuery from './getReceiptQuery.graphql';

const ReceiptContainer = ({ receiptData: { loading, getItinerary } }) => {

  if (loading) {
    return (
      <div className={s.root}>
        <Loader type={"text"} show={loading} />
      </div>
    );
  }

  return (
    <div className={s.root}>
      <Receipt data={getItinerary} />
    </div>
  );
}

ReceiptContainer.propTypes = {
  reservationId: PropTypes.number.isRequired,
  receiptData: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getItinerary: PropTypes.object.isRequired
  })
};

ReceiptContainer.defaultProps = {
  itineraryData: {
    loading: true,
  }
};
export default compose(
  withStyles(s),
  withQuery(getReceiptQuery,
    {
      name: 'receiptData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ReceiptContainer);
